class LogisticsInfo extends HTMLElement {
    constructor() {
        super();
    }  
    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    changeVariant(variantId) {

        const currentVariant = this.getVariantData().find((variant) => { return variant.id === variantId;});
        const rows = this.totalRows.find(row => row[0] == currentVariant.sku);
        currentVariant.min = rows ? rows[1] : 0;
        currentVariant.max = rows ? rows[2] : 0;
        if(currentVariant.available == false || (currentVariant.min == 0 && currentVariant.max == 0) || currentVariant.quantity < 1){
            this.style.display = 'none';
            return;
        }else{
            this.style.display = 'block';
        }
        this.min = currentVariant.min || 0;
        this.max = currentVariant.max || 0;
        this.quantity = currentVariant.quantity || 0;
        this.render();
       
    }
    async fetchXls(url) {
        const resp = await fetch(url);
        if (!resp.ok) throw new Error("网络错误: " + resp.status);

        // 转成 ArrayBuffer
        const arrayBuffer = await resp.arrayBuffer();
        const data = new Uint8Array(arrayBuffer);

        // 解析 Excel
        const workbook = XLSX.read(data, { type: "array" });

        // 取第一个 sheet
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // 转成二维数组（header:1 表示不自动转 JSON key，而是直接数组）
        const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        return rows;
    }

    connectedCallback() {
        const id = this.getAttribute('data-id') || 0;
        const currentVariant = this.getVariantData().find((variant) => { return variant.id === Number(id);});

        try {
            this.fetchXls(window.theme.fileData).then(rows => {
                this.totalRows = rows;
                var productInfo = rows.find(row => row[0] == currentVariant.sku);
                
                if(productInfo){
                    this.min = productInfo[1] || 0;
                    this.max = productInfo[2] || 0;
                }else{
                    this.min = this.getAttribute('data-min') || 0;
                    this.max = this.getAttribute('data-max') || 0;
                }
                this.render(); 
            }).catch(err => {
                err && console.error(err);
                this.min = this.getAttribute('data-min') || 0;
                this.max = this.getAttribute('data-max') || 0;
                this.render()
            });   
        } catch (error) {
            this.min = this.getAttribute('data-min') || 0;
            this.max = this.getAttribute('data-max') || 0;
            this.render(); 
        }
            // this.min = this.getAttribute('data-min') || 0;
            // this.max = this.getAttribute('data-max') || 0;
            // this.render(); 
       
    }
    // 设置时间格式
    ConversionTime(value){
        if (!value || isNaN(value)) return '';
        const now = new Date();
        const daysToAdd = parseInt(value, 10);
        const futureDate = new Date(now.getTime() + daysToAdd * 24 * 60 * 60 * 1000);
        const day = futureDate.getDate();
        const month = futureDate.toLocaleString('en-US', { month: 'short' });
        const suffix = (d) => {
            if (d > 3 && d < 21) return 'th';
            switch (d % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
            }
        };
        const formatted = `${month} ${day}${suffix(day)}`;
        return formatted;
    }
    render() {
        if((this.min == 0 && this.max == 0) || this.quantity < 1){
            this.style.display = 'none';
            return;
        }else{
            this.style.display = 'block';
        }
        
        this.querySelector('.min').innerHTML = this.ConversionTime(this.min);
        this.querySelector('.max').innerHTML = this.ConversionTime(this.max);   
    }
}   

if (!customElements.get('logistics-info')) {
    customElements.define('logistics-info', LogisticsInfo);
}